export const VIDEO_LIMIT_REACHED = 'videoLimit';

export const VIDEO_CHANGED = 'videoChanged';

export const VIDEO_STARTED_PLAYING = 'isPlaying';

export const START_ACTION = 'startAction';

export const SHOW_NEXT_GIRL = 'showNextGirl';

export const CREATE_SIGNUP = 'createSignup';

export const SENT_MESSAGE = 'sentMessage';
